/// <amd-module name="VC/Common/Components/VersionDropdown" />
import { shallowCompare } from "VSS/Core/Util/Object";
import { css } from "VSSUI/Util";
import * as React from "react";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ItemPickerDropdown, IPickListItem } from "VSSUI/PickList";

import * as Resources from "VC/Common/Resources";
import { VersionDropdownProvider } from "../Providers/VersionDropdownProvider";
import { IVersionDropdownProps, IVersionDropdownItem } from "./VersionDropdown.Props";

export class VersionDropdown extends VssComponent<IVersionDropdownProps, {}> {
    private provider: VersionDropdownProvider;

    public constructor(props: IVersionDropdownProps, context: IVssComponentContext) {
        super(props, context);

        this.provider = new VersionDropdownProvider(context.pageContext, props.providerOptions);
    }

    public render(): JSX.Element | null {
        const {
            className,
            dropdownClassName,
            id,
            tabIndex,
            hideSelectedItemIcon,
            dropdownIconProps,
            isOpen,
            autoFocus,
            isDrodownFullWidth,
            placeholderText,
            onToggleDropdown,
            titleTooltipFormat,
        } = this.props;

        return (
            <ItemPickerDropdown
                id={id}
                provider={this.provider}
                className={css("version-selector", className)}
                tabIndex={tabIndex}
                pickListClassName={css("version-selector-dropdown", dropdownClassName)}
                hideSelectedItemIcon={hideSelectedItemIcon}
                dropdownIconProps={dropdownIconProps}
                pickListWidth={isDrodownFullWidth ? undefined : 350}
                isOpen={isOpen}
                autoFocus={autoFocus}
                placeholderText={placeholderText}
                onRenderItemText={renderItemText}
                onToggleDropdown={onToggleDropdown}
                titleTooltipFormat={titleTooltipFormat}
            />
        );
    }

    public componentDidMount(): void {
        super.componentDidMount();

        if (this.props.componentRef) {
            this.props.componentRef(this);
        }
    }

    public componentWillReceiveProps(nextProps: IVersionDropdownProps): void {
        if (!shallowCompare(nextProps.providerOptions, this.props.providerOptions)) {
            this.provider = new VersionDropdownProvider(this.context.pageContext, nextProps.providerOptions);
        }
    }
}

function renderItemText(item: IPickListItem, data: IVersionDropdownItem): JSX.Element {
    const { prefix, lastName } = data.kind === "commit"
        ? { lastName: item.name } as PrefixAndLastName
        : splitVersionName(item.name);

    return <span>
        {
            prefix &&
            <span className="prefix-name">{prefix}</span>
        }
        {lastName}
        {
            data.isDefault &&
            <span className="default-badge">{Resources.VersionDropdown_DefaultBadge}</span>
        }
    </span>;
}

interface PrefixAndLastName {
    prefix?: string;
    lastName: string;
}

function splitVersionName(name: string): PrefixAndLastName {
    const slashIndex = name.lastIndexOf("/");
    return slashIndex > 0
        ? { prefix: name.substring(0, slashIndex + 1), lastName: name.substring(slashIndex + 1) }
        : { lastName: name };
}
